import { Profile } from "./Profile";
import { DateInfo } from "./DateInfo";
import { ResizableImage } from "./ResizableImage";
import ExternalLink from "./ExternalLink";
import { EmbeddedContent } from "./EmbeddedContent/EmbeddedContent";

enum BlogType {
    Social = 0,
    Suburb = 1,
    Estate = 2,
    Promotions = 3,
    Market = 4,
    Invest = 5,
    Landlord = 6
}

interface Blog {
    Id: string;
    UserId: string;

    Profile: Profile;

    Suburb: string;
    Type: BlogType;
    FormattedType: string;

    CreateDate: DateInfo;
    UpdatedDate: DateInfo;
    ElapsedPostTime: string;

    Title: string;
    Subtitle: string;
    Paragraph1: string;
    Paragraph2: string;

    Images: ResizableImage[];
    ExternalLinks: ExternalLink[];
    EmbeddedContent: EmbeddedContent[];

    Tags: string[];

    PDFTitle: string;
    PDFUrl: string;
}

export { Blog, BlogType }
